export default "__VITE_ASSET__DPb1ROpi__"